import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/User.svg'

export const IconUser = IconSVG as IconComponent
